import React, { useState, useEffect } from "react";
import { Form, Row, Col, message, Select, Card, Space, Divider } from "antd";
import CustomTitle from "../../components/CustomTitle.jsx";
import CustomSelect from "../../components/CustomSelect.jsx";
import CustomButton from "../../components/CustomButton.jsx";
import alertIcon from "../../assets/images/alertGroup.svg";
import truckIcon from "../../assets/images/truck.svg";
import locationIcon from "../../assets/images/location.svg";
import moment from "moment";
import clockIcon from "../../assets/images/clock.svg";
import { useToken } from "../../common/helper";
import { useSpin } from "../../components/SpinContext.js";
import { GetUsersByTeamIds } from "../../api's/settings.js";
import CustomParagraph from "../../components/CustomParagraph.jsx";
import FrequencySelector from "./FrequencySelector.jsx";
import TeamsSelector from "../../components/TeamsSelector.jsx";
import { DownOutlined } from "@ant-design/icons";
import { selectLocationState } from "../../reudx-toolkit/slice/LocationSlice";
import { useSelector } from "react-redux";
import { SendNotification } from "../../api's/onboarding.js";
import CheckboxSelector from "../../components/CheckBoxSelector.jsx";
import { getTeamsDDLOFFeature } from "../../common/utils/dropDown.js";

const NotificationForm = ({
  users,
  setUsers,
  onClose,
  notificationPermissions,
  drawerOpen,
  isEditing,
  productList,
  unauthorize,
  fetchNotifications,
  selectedType,
  setSelectedType,
  step,
  setStep,
  notificationData,
}) => {

  const [form] = Form.useForm();
  const { decodedUserToken, getUserID } = useToken();
  const [selectedOption, setSelectedOption] = useState(null);
  const { showSpin, hideSpin } = useSpin();
  const [selectedUserGroup, setSelectedUserGroup] = useState([]);
  let timezone = decodedUserToken()?.user_time_zone;
  const { locationList } = useSelector(selectLocationState);
  const { token } = useToken();
  const [selectedTeams, setSelectedTeams] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [teamsOptions, setTeamsOptions] = useState([]);
  const teams = useSelector((state) => state.teams.list);
  const [isRecipientsDropdownOpen, setIsRecipientsDropdownOpen] =
    useState(false);
  const [isTeamMembersDropdownOpen, setIsTeamMembersDropdownOpen] =
    useState(false);

  const [selectedNotificationMethod, setSelectedNotificationMethod] =
    useState(null);
  const [usersList, setUsersList] = useState([]);

  const changedByList = [
    { value: "15 minutes", label: "15 minutes" },
    { value: "30 minutes", label: "30 minutes" },
    { value: "1 hour", label: "1 hour" },
    { value: "Over 2 hours", label: "Over 2 hours" },
  ];
  const getUsersByTeams = (teamIds) => {
    if (!teamIds || teamIds?.length === 0) {
      setUsersList([]);
      return;
    }
    GetUsersByTeamIds(token, teamIds)
      .then((res) => {
        if (res?.data?.data?.data?.length > 0) {
          const flattenedUsers = res?.data?.data?.data?.flatMap((team) => {
            return (team.users || []).map((user) => ({
              ...user,
              teamId: team.id,
              teamName: team.name,
            }));
          });

          setUsersList(flattenedUsers);
          if (!isEditing) {
            form.setFieldsValue({ users: [] });
          }
        } else {
          setUsersList([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching users:", error);
        message.error("Error fetching users");
      });
  };

  const notificationTypes = [
    {
      id: "CRITICAL_ALERT",
      label: "Critical & At-Risk Alert",
      icon: alertIcon,
      description:
        "An alert noting an issue that has potentially or could lead to a compromised product",
    },
    {
      id: "PICKUP_DELIVERY",
      label: "Pickup / Delivery Confirmation",
      icon: truckIcon,
      description:
        "Notification when there has been a successful pick-up or delivery",
    },
    {
      id: "AT_LOCATION",
      label: "At Location",
      icon: locationIcon,
      description:
        "Notification when a product is at a specific location (e.g., a warehouse)",
    },
    {
      id: "ETA_BASED",
      label: "ETA",
      icon: clockIcon,
      description: "Notification when projected ETA moves by a set time",
    },
  ];

  // const userRole = decodedUserToken()?.role?.toLowerCase();
  // const isAdmin = userRole === "admin";
  const createSelf = notificationPermissions?.create_self;
  let userName = decodedUserToken()?.name;
  let userEmail = decodedUserToken()?.email;

  const allowedMethodsFromToken =
    decodedUserToken()?.notification_options || "";
  const isCreateSelf = createSelf;

  const notificationOptions = [
    { value: "MOBILE", label: "SMS" },
    { value: "EMAIL", label: "Email" },
    { value: "SLACK", label: "Slack" },
    { value: "TEAMS", label: "Teams" },
    { value: "WHATSAPP", label: "WhatsApp" },
  ].map((opt) => ({
    ...opt,
    disabled:
      isCreateSelf &&
      !["EMAIL", "SLACK", "TEAMS"].includes(opt.value) &&
      !allowedMethodsFromToken.includes(opt.value),
  }));

  const handleUserGroupChange = (newValues) => {
    setSelectedUserGroup(newValues);
  };
  const handleGroupClick = (e, teamId, users) => {
    e.stopPropagation();
    const currentValues = form.getFieldValue("users") || [];
    const enabledUserValues = users
      .filter(
        (user) =>
          !(
            selectedNotificationMethod &&
            user.notification_options?.[selectedNotificationMethod] === false
          )
      )
      .map((user) => `${user.id}::${user.teamId}`);
    const teamValue = `TEAM::${teamId}`;
    const isTeamSelected = currentValues.includes(teamValue);
    if (!isTeamSelected && enabledUserValues.length === 0) {
      message.warning(
        "No eligible users available for the selected notification method."
      );
      return;
    }
    let newValues;
    if (isTeamSelected) {
      newValues = currentValues.filter(
        (val) => val !== teamValue && !enabledUserValues.includes(val)
      );
    } else {
      newValues = [
        ...currentValues,
        ...enabledUserValues.filter((val) => !currentValues.includes(val)),
        teamValue,
      ];
    }

    form.setFieldsValue({ users: newValues });
  };

  const handleTypeSelect = (id) => {
    const selected = notificationTypes.find((t) => t.id === id);
    setSelectedType(selected);
    setSelectedProducts([]);
    setStep(2);
    if (id === "CRITICAL_ALERT") {
      setSelectedUserGroup(["Critical"]);
    } else if (id === "PICKUP_DELIVERY") {
      setSelectedUserGroup(["pickup"]);
    } else {
      setSelectedUserGroup(["all"]);
    }
  };

  const renderNotificationCard = (type, onClick, isSelected = false) => (
    <Card
      key={type.id}
      hoverable
      style={{
        marginBottom: "5px",
        borderRadius: "12px",
        border: isSelected ? "2px solid black" : "2px solid #E8E8E8",
        boxShadow: "none",
        transition: "all 0.2s ease-in-out",
      }}
      onMouseEnter={(e) => {
        if (!isSelected) e.currentTarget.style.backgroundColor = "#F5F5F5";
      }}
      onMouseLeave={(e) => {
        if (!isSelected) e.currentTarget.style.backgroundColor = "white";
      }}
      onClick={onClick}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "14px",
          position: type.id === "ETA_BASED" ? "relative" : "initial",
          top: type.id === "ETA_BASED" ? "8px" : "initial",
        }}
      >
        <img
          src={type.icon}
          alt={type.label}
          style={{
            marginLeft: "6px",
            width: "24px",
            height: type.id === "CRITICAL_ALERT" ? "50px" : "24px",
            objectFit: "contain",
          }}
          onError={(e) => (e.target.style.display = "none")}
        />
        <div>
          <CustomParagraph
            color="#000"
            text={type.label}
            fontSize="13px"
            fontWeight="600"
            marginBottom={5}
            style={{
              position: type.id === "ETA_BASED" ? "relative" : "initial",
              top: type.id === "ETA_BASED" ? "2px" : "initial",
            }}
          />
          <CustomParagraph
            color="#4B4B4B"
            style={{ position: "relative", top: "-2px" }}
            text={type.description}
            fontSize="11px"
            marginBottom={0}
          />
        </div>
      </div>
    </Card>
  );
  const renderTypeSpecificContent = (typeId) => {
    switch (typeId) {
      case "CRITICAL_ALERT":
        return (
          <Form.Item>
            <CustomTitle
              text="Alert type"
              fontSize="14px"
              fontWeight="600"
              lineHeight="16px"
              color="black"
              marginBottom="10px"
            />
            <CheckboxSelector
              selectedValues={selectedUserGroup}
              onChange={handleUserGroupChange}
              options={[
                {
                  value: "Critical",
                  label: "Critical alert",
                  description:
                    "An alert that is indicative of potential product compromise",
                },
                {
                  value: "At-risk",
                  label: "At-risk alert",
                  description:
                    "An alert that warns of a potential issue that may escalate into a critical alert",
                },
              ]}
            />
          </Form.Item>
        );

      case "PICKUP_DELIVERY":
        return (
          <Form.Item>
            <CustomTitle
              text="Type"
              fontSize="14px"
              fontWeight="600"
              lineHeight="16px"
              color="black"
              marginBottom="10px"
            />
            <CheckboxSelector
              selectedValues={selectedUserGroup}
              onChange={handleUserGroupChange}
              options={[
                {
                  value: "pickup",
                  label: "Pickup",
                  description:
                    "Notification when there has been a successful pickup",
                },
                {
                  value: "delivery",
                  label: "Delivery",
                  description:
                    "Notification when there has been a successful delivery",
                },
              ]}
            />
          </Form.Item>
        );
      case "AT_LOCATION":
        return (
          <Col span={24} style={{ marginTop: "20px" }}>
            <CustomTitle
              text="Location"
              fontSize="14px"
              fontWeight="600"
              lineHeight="16px"
              color="black"
              marginBottom="5px"
            />
            <Form.Item
              className="custom-input form-input-style"
              name="facility_type"
              rules={[{ message: "Select a type" }]}
            >
              <CustomSelect
                width="100%"
                placeholder="Select..."
                suffixIcon={<DownOutlined style={{ color: "#5E5E5E" }} />}
                options={
                  Array.isArray(locationList)
                    ? locationList.map((product) => ({
                        value: product?.id,
                        label: product?.name,
                      }))
                    : []
                }
                bgColor="#F3F3F3"
                textColor="#5E5E5E"
                borderRadius="8px"
                height="36px"
                border="none"
                placeholderColor="#5E5E5E"
              />
            </Form.Item>
          </Col>
        );

      case "ETA_BASED":
        return (
          <Col span={24} style={{ marginTop: "20px" }}>
            <CustomTitle
              text="Changed by"
              fontSize="14px"
              fontWeight="600"
              lineHeight="16px"
              color="black"
              marginBottom="5px"
            />
            <Form.Item name="changed_by" rules={[{ message: "Select a type" }]}>
              <CustomSelect
                width="100%"
                suffixIcon={<DownOutlined style={{ color: "#5E5E5E" }} />}
                placeholder="Select..."
                options={changedByList}
                bgColor="#F3F3F3"
                textColor="#5E5E5E"
                borderRadius="8px"
                height="36px"
                border="none"
                placeholderColor="#5E5E5E"
              />
            </Form.Item>
          </Col>
        );
      default:
        return null;
    }
  };

  const onFinish = (values) => {
    let sendToArray = [];

    if (!createSelf) {
      const selectedValues = values.users || [];
      const sendToMap = {};

      selectedValues.forEach((val) => {
        if (val.startsWith("TEAM::")) {
          const teamId = val.split("::")[1];
          sendToMap[teamId] = {
            id: teamId,
            users: [],
            select_all: true,
          };
        } else {
          const [userId, teamId] = val.split("::");

          if (!sendToMap[teamId]) {
            sendToMap[teamId] = {
              id: teamId,
              users: [],
            };
          }

          if (!selectedValues.includes(`TEAM::${teamId}`)) {
            sendToMap[teamId].users.push(userId);
          }
        }
      });

      // sendToArray = Object.values(sendToMap);
      sendToArray = Object.values(sendToMap).map((item) => ({
        ...item,
        create_self: teamsOptions.find((t) => t.id === item.id)?.permissions
          ?.create_self,
      }));
    }

    try {
      const isSpecialType =
        selectedType?.id === "ETA_BASED" || selectedType?.id === "AT_LOCATION";
      const payload = {
        alert_type: selectedType?.id,
        is_critical: isSpecialType
          ? false
          : selectedUserGroup.includes("Critical"),
        is_at_risk: isSpecialType
          ? false
          : selectedUserGroup.includes("At-risk"),
        is_pickup_confirmation: isSpecialType
          ? false
          : selectedUserGroup.includes("pickup"),
        is_delivery_confirmation: isSpecialType
          ? false
          : selectedUserGroup.includes("delivery"),
        location: values.facility_type || null,
        change_by: values.changed_by || null,
        products: values.products.includes("all_products")
          ? productList.map((product) => product.id)
          : values.products || [],
        frequency: values.frequency,
        time_1: values.send_at_1 ? values.send_at_1.format("h:mma") : null,
        time_2: values.send_at_2 ? values.send_at_2.format("h:mma") : null,
        day: values.day_of_week || null,
        notification_method: values.notification_method,
        notification_channel: values.notification_channel,
        send_to: sendToArray,
        ...(createSelf && { create_self: true }),
        created_by: decodedUserToken()?.id,
        ...(isEditing && { id: notificationData?.id }),
        teams: selectedTeams.map((team) => team.id),
        ...(selectedUsers?.length > 0 &&
          teamsOptions?.length === 0 && {
            users: selectedUsers.filter(Boolean),
          }),
      };
      showSpin();
      SendNotification(token, payload, isEditing, notificationData?.id)
        .then((res) => {
          const data = res?.data || null;
          if (data?.data?.is_success) {
            form.resetFields();
            onClose();
            fetchNotifications();
            message.success(data?.data?.message);
          } else {
            message.error(data?.data?.message);
          }
        })
        .catch((error) => {
          unauthorize(error);
        })
        .finally(() => {
          hideSpin();
        });
    } catch (error) {
      console.error("Error preparing payload:", error);
      message.error("Failed to save notification.");
    }
  };

  const handleSelectChange = (value) => {
    setSelectedOption(value);
    setSelectedNotificationMethod(value);
    form.setFieldsValue({ team_members: [] });
    if (!createSelf) {
      form.setFieldsValue({ users: [] });
    }

    const isOldMobileType =
      selectedOption === "MOBILE" || selectedOption === "WHATSAPP";
    const isNewMobileType = value === "MOBILE" || value === "WHATSAPP";
    if (isOldMobileType !== isNewMobileType) {
      form.setFieldsValue({ notification_channel: "" });
    }
  };
  const teamsData = usersList.reduce((acc, user) => {
    const { teamId, teamName } = user;
    const existingTeam = acc.find((t) => t.teamId === teamId);
    if (existingTeam) {
      existingTeam.users.push(user);
    } else {
      acc.push({
        teamId,
        teamName,
        users: [user],
      });
    }

    return acc;
  }, []);

  useEffect(() => {
    setStep(1);
    if (isEditing) {
      setStep(2);
    }
  }, [drawerOpen]);

  useEffect(() => {
    if (!isEditing && step === 1) {
      form.resetFields();
      setSelectedOption(null);
      setSelectedTeams([]);

      form.setFieldsValue({ users: [], teams: [] });
      setUsersList([]);
    }
  }, [step, isEditing]);

  useEffect(() => {
    if (drawerOpen && !isEditing) {
      form.resetFields();
      setSelectedTeams([]);
      setSelectedOption(null);
      setSelectedType(null);
    }
  }, [drawerOpen, isEditing]);

  useEffect(() => {
    if (isEditing && notificationData && teamsOptions?.length) {
      const selectedTeamObjects = teamsOptions.filter((team) =>
        (notificationData.teams || []).includes(team.id)
      );

      setSelectedTeams(selectedTeamObjects);
      form.setFieldsValue({ teams: selectedTeamObjects });
      getUsersByTeams(notificationData.teams || []);
    }
  }, [isEditing, notificationData, teamsOptions]);
  useEffect(() => {
    if (createSelf) {
      const id = getUserID();
      if (id) {
        form.setFieldsValue({
          users: [
            {
              value: `${id}`,
              label: userName,
            },
          ],
        });
      }
    }
  }, [createSelf, users, selectedType]);

  useEffect(() => {
    if (isEditing && notificationData) {
      const transformedUsers = (notificationData.send_to || []).flatMap(
        (team) => {
          if (team.select_all) {
            return [`TEAM::${team.id}`];
          }
          return (team.users || []).map((user) => `${user.id}::${team.id}`);
        }
      );

      if (notificationData.users) {
        const selectedUserOptions = notificationData.users
          .map((userObj) => {
            const found = users.find((u) => u.company_user_id === userObj.id);
            return found
              ? { label: found.name, value: found.company_user_id }
              : null;
          })
          .filter(Boolean);

        if (selectedUserOptions.length > 0) {
          form.setFieldsValue({
            team_members: notificationData.users.map((u) => u.id),
          });
          setSelectedUsers(notificationData.users.map((u) => u.id));
        }
      }
      form.setFieldsValue({
        products: notificationData.products.map((p) => p.id),
        notification_method: notificationData.notification_method,
        notification_channel: notificationData.notification_channel,
        facility_type: notificationData.location || undefined,
        users: transformedUsers,
        changed_by: notificationData.change_by || undefined,
        frequency: notificationData.frequency,
        day_of_week:
          notificationData.frequency === "WEEKLY"
            ? notificationData.day
            : undefined,
        send_at_1: notificationData.time_1
          ? moment(notificationData.time_1, "h:mma")
          : null,
        send_at_2: notificationData.time_2
          ? moment(notificationData.time_2, "h:mma")
          : null,
      });
      setSelectedOption(notificationData.notification_method);
      setSelectedNotificationMethod(notificationData.notification_method);

      const typeMatch = notificationTypes.find(
        (t) => t.id === notificationData.alert_type
      );
      if (typeMatch) setSelectedType(typeMatch);
      const userGroupSelections = [];

      if (notificationData.is_critical) {
        userGroupSelections.push("Critical");
      }
      if (notificationData.is_at_risk) {
        userGroupSelections.push("At-risk");
      }
      if (notificationData.is_pickup_confirmation) {
        userGroupSelections.push("pickup");
      }
      if (notificationData.is_delivery_confirmation) {
        userGroupSelections.push("delivery");
      }
      setSelectedUserGroup(userGroupSelections);
    }
  }, [isEditing, notificationData]);
  useEffect(() => {
    getTeamsDDLOFFeature(token, "Notifications").then((val) => {
      if (val && val.length > 0) {
        setTeamsOptions(val);
      }
    });
  }, []);

  return (
    <Form
      className="custom-form form-item"
      form={form}
      layout="vertical"
      onFinish={onFinish}
      style={{ display: "flex", flexDirection: "column", height: "100%" }}
    >
      <div
        style={{
          position: "absolute",
          top: "40px",
          paddingTop: "0px",
          left: "0",
          padding: "0px 32px",
          width: "100%",
          background: "#fff",
          zIndex: "2",
        }}
      >
        <CustomTitle
          text={!isEditing ? "Add notification" : "Edit notification"}
          fontSize={20}
          fontWeight="700"
          lineHeight="32px"
          color="#000"
          marginBottom={0}
        />
      </div>
      <div
        style={{
          flex: 1,
          paddingBottom: "130px",
          paddingTop: "18px",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        }}
        className="custom-scrollbar"
      >
        {step === 1 && !isEditing ? (
          <div className="custom-card">
            <CustomParagraph
              color="#5E5E5E"
              text="Choose a notification type"
              fontSize="14px"
            />
            <Space direction="vertical" size={12} style={{ width: "100%" }}>
              {notificationTypes.map((type) =>
                renderNotificationCard(
                  type,
                  () => handleTypeSelect(type.id),
                  selectedType?.id === type.id
                )
              )}
            </Space>
          </div>
        ) : (
          <>
            {step === 2 && selectedType && (
              <div className="custom-card">
                {renderNotificationCard(selectedType, null, true)}
                <div style={{ marginTop: "16px" }}>
                  {renderTypeSpecificContent(selectedType.id)}
                </div>
              </div>
            )}
            <Divider style={{ borderColor: "#D9D9D9" }} />
            {!createSelf &&
              !(
                teams.length == 1 && teams[0].name.toLowerCase() == "default"
              ) && (
                <>
                  <CustomTitle
                    text="Teams with Access"
                    fontSize={14}
                    fontWeight="600"
                    marginTop={"20px"}
                  />
                  <Form.Item
                    name="teams"
                    className="custom-input form-input-style"
                    rules={[
                      {
                        required: true,
                        message: "Please select at least one team",
                      },
                    ]}
                  >
                    <TeamsSelector
                      teamsOptions={teamsOptions}
                      selectedTeams={selectedTeams}
                      onChange={(val) => {
                        setSelectedTeams(val);
                        form.setFieldsValue({ teams: val });

                        const selectedTeamIds = val.map(
                          (team) => team.id || team
                        );
                        getUsersByTeams(selectedTeamIds);
                      }}
                      formState={isEditing ? "edit" : "add"}
                    />
                  </Form.Item>
                </>
              )}

            <Col span={24}>
              <Form.Item
                className="custom-input form-input-style"
                label="Products"
                name="products"
                style={{ marginBottom: "0px" }}
                rules={[
                  {
                    required: true,
                    message: "Please select at least one product",
                  },
                ]}
              >
                <Select
                  mode="multiple"
                  className="custom-product-select"
                  showSearch={false}
                  placeholder="Select..."
                  optionLabelProp="label"
                  value={selectedProducts}
                  defaultValue={selectedProducts}
                  onChange={(value) => {
                    if (value.includes("all_products")) {
                      setSelectedProducts(["all_products"]);
                      form.setFieldsValue({ products: ["all_products"] });
                    } else {
                      setSelectedProducts(value);
                      form.setFieldsValue({ products: value });
                    }
                  }}
                  style={{
                    minHeight: "36px",
                    border: "0px",
                    backgroundColor: "#F3F3F3",
                    color: "#5E5E5E",
                    borderRadius: "8px",
                    lineHeight: "38px",
                    width: "100%",
                  }}
                >
                  {Array.isArray(productList) && productList?.length > 0 && (
                    <Select.Option value="all_products" label="All Products">
                      All Products
                    </Select.Option>
                  )}

                  {Array.isArray(productList) &&
                    productList.map((product) => (
                      <Select.Option
                        key={product.id}
                        value={product.id}
                        label={product.name}
                        disabled={selectedProducts.includes("all_products")}
                      >
                        {product.name}
                      </Select.Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>

            <FrequencySelector
              timezone={timezone}
              initialFrequency={notificationData?.frequency}
              form={form}
            />

            <Row style={{ width: "100%" }}>
              <Col span={24}>
                <Form.Item
                  className="custom-input form-input-style"
                  label="Notify via"
                  name="notification_method"
                  rules={[
                    {
                      required: true,
                      message: "Please select a notification method",
                    },
                  ]}
                >
                  <CustomSelect
                    options={notificationOptions}
                    placeholder="Select"
                    onChange={handleSelectChange}
                    width="100%"
                    height="36px"
                    border="0px"
                    bgColor="#F3F3F3"
                    textColor="#5E5E5E"
                    borderRadius="8px"
                    placeholderColor="#4B4B4B"
                  />
                </Form.Item>
              </Col>

              {(selectedOption === "TEAMS" || selectedOption === "SLACK") && (
                <Col span={24}>
                  <p
                    style={{
                      color: "#5E5E5E",
                      fontSize: "12px",
                      position: "relative",
                      bottom: "10px",
                      marginBottom: "0px",
                    }}
                  >
                    A ZoomLogi representative will contact you.
                  </p>
                </Col>
              )}
            </Row>
            {(teams.length !== 1 ||
              teams[0].name.toLowerCase() !== "default") && (
              <Col span={24}>
                <Form.Item
                  className="custom-input form-input-style custom-select-disabled-only"
                  label="Recipients"
                  name="users"
                  rules={[
                    {
                      required: true,
                      message: "Please select at least one recipient",
                    },
                  ]}
                  style={{ marginBottom: "0px" }}
                >
                  <Select
                    className="custom-optgroup-label"
                    mode="multiple"
                    tagRender={(props) => {
                      const { label, value, closable, onClose } = props;
                      if (!value || typeof value !== "string") return null;

                      const selectedValues =
                        form?.getFieldValue?.("users") || [];
                      if (value.startsWith("TEAM::")) {
                        const teamId = value.split("::")[1];
                        const team = teamsData.find((t) => t.teamId === teamId);

                        return (
                          <div
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              padding: "0px 8px",
                              height: "25px",
                              background: "#5E5E5E",
                              borderRadius: "8px",
                              marginRight: "4px",
                            }}
                          >
                            <span
                              style={{
                                fontSize: "10px",
                                fontWeight: 600,
                                color: "white",
                              }}
                            >
                              All members of {team?.teamName || "Team"}
                            </span>
                            {closable && (
                              <span
                                onClick={() => {
                                  const newSelected = selectedValues.filter(
                                    (val) =>
                                      val !== value &&
                                      !team?.users
                                        .map((u) => `${u.id}::${u.teamId}`)
                                        .includes(val)
                                  );
                                  form.setFieldsValue({ users: newSelected });
                                }}
                                style={{
                                  marginLeft: "6px",
                                  cursor: "pointer",
                                  color: "white",
                                  fontWeight: "bold",
                                }}
                              >
                                ×
                              </span>
                            )}
                          </div>
                        );
                      }

                      if (value.includes("::")) {
                        const teamId = value.split("::")[1];
                        if (selectedValues.includes(`TEAM::${teamId}`)) {
                          return null;
                        }
                      }
                      return (
                        <div
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            padding: "0px 8px",
                            color: "white",
                            height: "25px",
                            fontSize: "10px",
                            background: "#5E5E5E",
                            borderRadius: "8px",
                            marginRight: "4px",
                          }}
                        >
                          <span style={{ fontWeight: 600 }}>{label}</span>
                          {closable && (
                            <span
                              onClick={onClose}
                              style={{
                                color: "white",
                                marginLeft: "6px",
                                cursor: "pointer",
                                fontWeight: "bold",
                                fontSize: "14px",
                              }}
                            >
                              ×
                            </span>
                          )}
                        </div>
                      );
                    }}
                    dropdownRender={(menu) => (
                      <div
                        className="custom-optgroup-label no-scrollbar"
                        style={{ maxHeight: "250px", overflowY: "auto" }}
                      >
                        {menu}
                      </div>
                    )}
                    disabled={createSelf}
                    placeholder="Select..."
                    optionLabelProp="label"
                    style={{
                      border: createSelf ? "2px solid #E2E2E2" : "0px",
                      backgroundColor: createSelf ? "#ffffff" : "#F3F3F3",
                      minHeight: "36px",
                      color: "#5E5E5E",
                      borderRadius: "8px",
                      lineHeight: "38px",
                      width: "100%",
                    }}
                    open={isRecipientsDropdownOpen}
                    onDropdownVisibleChange={(open) => {
                      const hasNotifyVia = !!form.getFieldValue(
                        "notification_method"
                      );
                      const hasTeams =
                        Array.isArray(form.getFieldValue("teams")) &&
                        form.getFieldValue("teams")?.length > 0;

                      if (open) {
                        if (hasNotifyVia && hasTeams) {
                          setIsRecipientsDropdownOpen(true);
                        } else {
                          message.error(
                            "Please select both 'Notify via' and at least one Team first."
                          );
                          setIsRecipientsDropdownOpen(false);
                        }
                      } else {
                        setIsRecipientsDropdownOpen(false);
                      }
                    }}
                  >
                    {teamsData.map(({ teamId, teamName, users }) => (
                      <Select.OptGroup
                        key={teamId}
                        label={
                          <div
                            onClick={(e) => {
                              const teamPermission = teamsOptions.find(
                                (t) => t.id === teamId
                              )?.permissions?.is_create;
                              if (teamPermission) {
                                handleGroupClick(e, teamId, users);
                              } else {
                                e.stopPropagation();
                                message.warning(
                                  "You do not have permission to select all members of this team."
                                );
                              }
                            }}
                            style={{
                              fontWeight: "400",
                              fontSize: "14px",
                              cursor:
                                teamsOptions.find((t) => t.id === teamId)
                                  ?.permissions?.is_create &&
                                !teamsOptions.find((t) => t.id === teamId)
                                  ?.permissions?.create_self
                                  ? "pointer"
                                  : "not-allowed",
                              padding: "4px 8px",
                              userSelect: "none",
                              color:
                                teamsOptions.find((t) => t.id === teamId)
                                  ?.permissions?.is_create &&
                                !teamsOptions.find((t) => t.id === teamId)
                                  ?.permissions?.create_self
                                  ? "#000"
                                  : "#B0B0B0",
                            }}
                          >
                            All members of {teamName} ({users.length})
                          </div>
                        }
                      >
                        {users.map((user) => {
                          let val1 =
                            selectedNotificationMethod &&
                            user.notification_options?.[
                              selectedNotificationMethod
                            ] === false;
                          let e = decodedUserToken()?.email;
                          let val2 =
                            teamsOptions.find((t) => t.id === user.teamId)
                              ?.permissions?.create_self && user.email !== e;
                          const isDisabled = val1 || val2;
                          // (selectedNotificationMethod &&
                          // user.notification_options?.[
                          //   selectedNotificationMethod
                          // ] === false ||  (teamsOptions.find(t => t.id === user.teamId)?.permissions?.create_self && user.email === decodedUserToken()?.email));
                          const value = `${user.id}::${user.teamId}`;
                          return (
                            <Select.Option
                              key={value}
                              value={value}
                              label={user.name || user.email || user.id}
                              disabled={isDisabled}
                              style={{
                                color: isDisabled ? "#B0B0B0" : "#000000",
                                paddingLeft: "16px",
                                fontSize: "14px",
                              }}
                            >
                              {user.name || user.email || user.id}
                            </Select.Option>
                          );
                        })}
                      </Select.OptGroup>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            )}
            {teams.length === 1 &&
              teams[0].name.toLowerCase() === "default" && (
                <Col span={24}>
                  <Form.Item
                    className="custom-input form-input-style"
                    label="Recipients"
                    name="team_members"
                    style={{ marginBottom: "0px" }}
                    rules={[
                      {
                        required: true,
                        message: "Please select at least one user",
                      },
                    ]}
                  >
                    
                    <Select
                      mode="multiple"
                    showSearch={false}
                      className="custom-user-select"
                      placeholder="Select..."
                      value={selectedUsers} // array of user IDs
                      onChange={(value) => {
                        setSelectedUsers(value);
                        form.setFieldsValue({ team_members: value });
                      }}
                      tagRender={({ value, closable, onClose }) => {
                        const matchedUser = users.find(
                          (u) => u.company_user_id === value
                        );
                        return (
                          <div
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              padding: "0px 10px",
                              position:"relative",
                              top:"-3px",
                              height:"25px",
                              marginRight: 6,
                              background: "#5e5e5e",
                              color: "#fff",
                              fontSize: "10px",
                              fontWeight: "600",
                              borderRadius: "4px",
                            }}
                          >
                            {matchedUser?.name || value}
                            {closable && (
                              <span
                                onClick={onClose}
                                style={{
                                  // height: "36px",
                                  marginLeft: 8,
                                  cursor: "pointer",
                                  color: "#fff",
                                  fontWeight: "bold",
                                  fontSize: "12px",
                                  lineHeight: "1",
                                }}
                              >
                                ×
                              </span>
                            )}
                          </div>
                        );
                      }}
                      optionLabelProp="label"
                      style={{
                      minHeight:"36px",
                        border: "0px",
                        backgroundColor: "#F3F3F3",
                        color: "#5E5E5E",
                        borderRadius: "8px",
                        lineHeight: "38px",
                        width: "100%",
                      }}
                    >
                      {users.map((user) => {
                        const selectedNotifyVia = form.getFieldValue(
                          "notification_method"
                        );
                        const isDisabled =
                          selectedNotifyVia &&
                          user.notification_options?.[selectedNotifyVia] ===
                            false;

                        return (
                          <Select.Option
                            key={user.company_user_id}
                            value={user.company_user_id}
                            label={user.name}
                            disabled={isDisabled}
                            style={{ fontSize: "14px" }}
                          >
                            <div
                              style={{ color: isDisabled ? "#B0B0B0" : "#000" }}
                            >
                              <strong>{user.name}</strong> ({user.email})
                              {isDisabled && (
                                <span
                                  style={{
                                    fontStyle: "italic",
                                    fontSize: "11px",
                                    marginLeft: "6px",
                                  }}
                                >
                                  (Not available via {selectedNotifyVia})
                                </span>
                              )}
                            </div>
                          </Select.Option>
                        );
                      })}
                    </Select>
                  </Form.Item>
                </Col>
              )}
          </>
        )}
        {step !== 1 && (
          <div
            style={{
              background: "#fff",
              position: "absolute",
              bottom: "0",
              left: "0",
              width: "100%",
              padding: "0 24px 24px",
            }}
          >
            <Row gutter={[0, 8]} style={{ marginTop: "0" }}>
              <CustomButton
                key="button1"
                text="Save"
                bgColor="#000"
                htmlType="submit"
                color="#fff"
                fontSize="16px"
                fontWeight="600"
                boxShadow="none"
                height="48px"
                width="100%"
                borderRadius={"8px"}
              />

              <CustomButton
                key="button2"
                text="Cancel"
                padding={"11.5px 0px 12px 0px"}
                bgColor="transparent"
                color="#000"
                fontSize="16px"
                fontWeight="600"
                boxShadow="none"
                height="auto"
                width="100%"
                border="none"
                marginTop="0px"
                onClick={onClose}
              />
            </Row>
          </div>
        )}
      </div>
    </Form>
  );
};

export default NotificationForm;
